import { Text } from '@carouselgg/nexus/text'
import { Button } from '@carouselgg/nexus/button'
import { UserPlus } from '@carouselgg/nexus/icon'
import type { FreeAgentRoom } from './labels'
import { roomHeadline, roomDetail, roomBackup } from './freeAgentRoomCopy'
import styles from './FreeAgentRoomNote.module.css'

/**
 * Under the team meter on the Compete spotlight: the meter counts teams, which
 * says nothing to a player without one. This says where they would fit.
 */
export function FreeAgentRoomNote({ room, onJoinPool }: { room: FreeAgentRoom; onJoinPool: () => void }) {
  const detail = roomDetail(room)
  const backup = roomBackup(room)
  return (
    <div className={styles.note}>
      <UserPlus size={18} className={styles.icon} />
      <div className={styles.text}>
        <Text size="sm" weight="semibold">{roomHeadline(room)}</Text>
        {detail && <Text size="xs" muted>{detail}</Text>}
        {backup && <Text size="xs" muted>{backup}</Text>}
      </div>
      <Button variant="ghost" size="sm" onClick={onJoinPool} className={styles.join}>
        Join the free-agent pool
      </Button>
    </div>
  )
}
